// Costs — fixed opex (single tunable scalar), Wirex platform floor, and
// variable card-program costs that come from the commercial sheet.
//
// Per founder lock: no headcount detail, no role ramp. fixedOpexMonthly is
// one number you slide. The Wirex floor is a top-up: Wirex must receive a
// minimum monthly revenue across all fee streams; Pulsar pays the shortfall.

/**
 * Wirex floor shortfall for a month — what Pulsar pays Wirex on top of
 * earned (interchange share + FX passthrough) to clear the monthly minimum.
 *
 * @param {object} inputs
 * @param {number} month                1..36
 * @param {number} wirexEarnedEur       Wirex's already-earned share this month
 *                                      (Pulsar's interchange COMPLEMENT + Wirex's FX passthrough)
 * @returns {number} EUR shortfall Pulsar pays Wirex
 */
export function wirexFloorShortfall(inputs, month, wirexEarnedEur) {
  const floorUsd =
    month <= 12 ? inputs.wirex.floorY1 : month <= 24 ? inputs.wirex.floorY2 : inputs.wirex.floorY3;
  const floorEur = floorUsd / inputs.fx.eurToUsd;
  return Math.max(0, floorEur - wirexEarnedEur);
}

/**
 * Dispute / chargeback handling cost. Commercial sheet says $25 per dispute;
 * the frequency stays editable because realized chargebacks depend on fraud,
 * merchant mix, and cardholder behavior.
 *
 * @param {object} inputs
 * @param {number} activeCardholders
 * @returns {number}
 */
export function wirexDisputeCost(inputs, activeCardholders) {
  const disputesPer1000Tx = inputs.wirex?.disputesPer1000Tx ?? 0;
  const txPerCardholderMo = inputs.wirex?.transactionsPerCardholderMo ?? 0;
  const disputeFee = inputs.wirex?.disputeFee ?? 0;
  const disputes = (activeCardholders * txPerCardholderMo * disputesPer1000Tx) / 1000;
  return disputes * disputeFee;
}
